<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Hotel Booking Update",
      items: [
        {
          text: "Hotel Booking",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
        bookingId:"",
        booking_statuses:[],
      form: {
          target_api:"",
          total_guests:"",
          check_in_date:"",
          check_out_date:"",
          rooms:"",
          nights:"",
          booking_status_id:"",
          payment_status:"",
          base_fare:"",
          total_tax:"",
          gross_fare:"",
          invoice_fare:"",
          commission:"",
          markup:"",
          hotel_name:"",
          address:"",
          region:"",
            country_code:"",
          refundable:"",
          cancellation_fee:"",
          contact_email:"",
          contact_phone:"",
          contact_phone_code:""
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        target_api: {
        required,
      },
        total_guests: {
        required,
      },
        check_in_date: {
            required,
        },
        check_out_date: {
            required,
        },
        rooms: {
            required,
        },
        nights: {
            required,
        },
        booking_status_id: {
            required,
        },
        payment_status: {
            required,
        },
        base_fare: {
            required,
        },gross_fare: {
            required,
        },
        total_tax: {
            required,
        },
        invoice_fare: {
            required,
        },
        markup: {
            required,
        },
        commission: {
            required,
        },
        hotel_name: {
            required,
        },address: {
            required,
        },country_code: {
            required,
        },
        region: {
            required,
        },
        refundable: {
            required,
        },
        cancellation_fee: {
            required,
        },
        contact_email: {
            required,
        },
        contact_phone: {
            required,
        },
        contact_phone_code: {
            required,
        },
    },
  },
  created() {
    this.bookingId = this.$route.params.id;
  },
  mounted() {
    this.getBookingDetail();
    this.getBookingStatuses();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getBookingDetail() {
          try {
              axios
                  .post("/api/hotel-booking/" + this.bookingId, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.form.target_api=response.data.data.api_vendor.api_provider;
                          this.form.total_guests=response.data.data.total_number_of_guest;
                          this.form.check_in_date=response.data.data.check_in;
                          this.form.check_out_date=response.data.data.check_out;
                          this.form.rooms=response.data.data.no_of_room;
                          this.form.nights=response.data.data.no_of_night_stay;
                          this.form.booking_status_id=response.data.data.booking_status.status_tag;
                          this.form.payment_status=response.data.data.payment_status;
                          this.form.base_fare=response.data.data.base_fare;
                          this.form.total_tax=response.data.data.total_tax;
                          this.form.gross_fare=response.data.data.total_fare;
                          this.form.invoice_fare=response.data.data.invoice_fare;
                          this.form.commission=response.data.data.commission;
                          this.form.markup=response.data.data.markup;
                          this.form.hotel_name=response.data.data.hotel_name;
                          this.form.address=response.data.data.street_address;
                          this.form.region=response.data.data.region;
                          this.form.country_code=response.data.data.country_code;
                          this.form.refundable=response.data.data.is_refundable;
                          this.form.cancellation_fee=response.data.data.cancellation_fee;
                          this.form.contact_email=response.data.data.contact_email;
                          this.form.contact_phone=response.data.data.contact_phone_number;
                          this.form.contact_phone_code=response.data.data.contact_phone_code;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getBookingStatuses() {
          try {
              axios
                  .get("/api/flight-booking/statuses", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.booking_statuses = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/hotel-booking/update", {
          id: this.bookingId,
            target_api: this.form.target_api,
            total_guests: this.form.total_guests,
            check_in_date: this.form.check_in_date,
            check_out_date: this.form.check_out_date,
            rooms: this.form.rooms,
            nights: this.form.nights,
            booking_status_id: this.form.booking_status_id,
            payment_status:this.form.payment_status,
            base_fare: this.form.base_fare,
            gross_fare: this.form.gross_fare,
            total_tax: this.form.total_tax,
            invoice_fare: this.form.invoice_fare,
            commission: this.form.commission,
            markup: this.form.markup,
            hotel_name: this.form.hotel_name,
            address: this.form.address,
            region: this.form.region,
            country_code: this.form.country_code,
            refundable: this.form.refundable,
            cancellation_fee: this.form.cancellation_fee,
            contact_email: this.form.contact_email,
            contact_phone: this.form.contact_phone,
            contact_phone_code: this.form.contact_phone_code,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.hotelBookingUpdateForm.reset();
            this.$swal("Good job!", "Hotel Booking Updated", "success");
            this.$router.push({ name: "hotel_booking_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="hotelBookingUpdateForm" @submit.prevent="formSubmit">
              <div class="row">
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Target Api</label>
                          <input
                              id="target_api"
                              v-model="form.target_api"
                              name="target_api"
                              type="text"
                              class="form-control"
                              placeholder="target api"
                              :class="{ 'is-invalid': submitted && $v.form.target_api.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.target_api.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.target_api.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Total Guests</label>
                          <input
                              id="total_guests"
                              v-model="form.total_guests"
                              name="total_guests"
                              type="text"
                              class="form-control"
                              placeholder="total guests"
                              :class="{ 'is-invalid': submitted && $v.form.total_guests.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.total_guests.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.total_guests.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <b-form-group
                          id="check_in_date"
                          label-cols-sm="12"
                          label-cols-lg="12"
                          label="check in date"
                          label-for="Check in date"
                      >
                          <b-form-datepicker id="check_in_date" v-model="form.check_in_date" value="form.check_in_date"  class="mb-2"></b-form-datepicker>
                      </b-form-group>
                  </div>
                  <div class="col-md-6">
                      <b-form-group
                          id="check_out_date"
                          label-cols-sm="12"
                          label-cols-lg="12"
                          label="Check out Date"
                          label-for="Check out date"
                      >
                          <b-form-datepicker id="check_out_date" v-model="form.check_out_date" value="form.check_out_date"  class="mb-2"></b-form-datepicker>
                      </b-form-group>
                  </div>

                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Rooms</label>
                          <input
                              id="rooms"
                              v-model="form.rooms"
                              name="rooms"
                              type="text"
                              class="form-control"
                              placeholder="rooms"
                              :class="{ 'is-invalid': submitted && $v.form.rooms.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.rooms.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.rooms.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Nights</label>
                          <input
                              id="nights"
                              v-model="form.nights"
                              name="nights"
                              type="text"
                              class="form-control"
                              placeholder="nights"
                              :class="{ 'is-invalid': submitted && $v.form.nights.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.nights.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.nights.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Select Booking Status</label>
                          <select
                              id="booking_status_id"
                              name="booking_status_id"
                              v-model="form.booking_status_id"
                              class="form-control"
                              placeholder="Type Status">
                              <option v-for="(status, index) in booking_statuses" :value="status.status_tag"
                                      v-bind:key="index">{{ status.status_name }}
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Select Payment Status</label>
                          <select
                              id="payment_status"
                              name="payment_status"
                              v-model="form.payment_status"
                              class="form-control"
                              placeholder="Type Status">
                              <option value="0">Not paid</option>
                              <option value="1">Paid</option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Gross Fare</label>
                          <input
                              id="gross_fare"
                              v-model="form.gross_fare"
                              name="gross_fare"
                              type="text"
                              class="form-control"
                              placeholder="gross fare"
                              :class="{ 'is-invalid': submitted && $v.form.gross_fare.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.gross_fare.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.gross_fare.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Total Tax</label>
                          <input
                              id="total_tax"
                              v-model="form.total_tax"
                              name="total_tax"
                              type="text"
                              class="form-control"
                              placeholder="total tax"
                              :class="{ 'is-invalid': submitted && $v.form.total_tax.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.total_tax.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.total_tax.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Base Fare</label>
                          <input
                              id="base_fare"
                              v-model="form.base_fare"
                              name="base_fare"
                              type="text"
                              class="form-control"
                              placeholder="base fare"
                              :class="{ 'is-invalid': submitted && $v.form.base_fare.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.base_fare.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.base_fare.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Invoice Fare</label>
                          <input
                              id="invoice_fare"
                              v-model="form.invoice_fare"
                              name="invoice_fare"
                              type="text"
                              class="form-control"
                              placeholder="base fare"
                              :class="{ 'is-invalid': submitted && $v.form.invoice_fare.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.invoice_fare.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.invoice_fare.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Commission</label>
                          <input
                              id="commission"
                              v-model="form.commission"
                              name="commission"
                              type="text"
                              class="form-control"
                              placeholder="commission"
                              :class="{ 'is-invalid': submitted && $v.form.commission.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.commission.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.commission.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Markup</label>
                          <input
                              id="markup"
                              v-model="form.markup"
                              name="markup"
                              type="text"
                              class="form-control"
                              placeholder="markup"
                              :class="{ 'is-invalid': submitted && $v.form.markup.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.markup.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.markup.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Hotel Name</label>
                          <input
                              id="hotel_name"
                              v-model="form.hotel_name"
                              name="hotel_name"
                              type="text"
                              class="form-control"
                              placeholder="hotel name"
                              :class="{ 'is-invalid': submitted && $v.form.hotel_name.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.hotel_name.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.hotel_name.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Address</label>
                          <input
                              id="address"
                              v-model="form.address"
                              name="address"
                              type="text"
                              class="form-control"
                              placeholder="address"
                              :class="{ 'is-invalid': submitted && $v.form.address.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.address.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.address.required">This value is required.</span>
                          </div>
                      </div>
                  </div>

                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Region</label>
                          <input
                              id="region"
                              v-model="form.region"
                              name="region"
                              type="text"
                              class="form-control"
                              placeholder="region"
                              :class="{ 'is-invalid': submitted && $v.form.region.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.region.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.region.required">This value is required.</span>
                          </div>
                      </div>
                  </div>

                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Country Code</label>
                          <input
                              id="country_code"
                              v-model="form.country_code"
                              name="country_code"
                              type="text"
                              class="form-control"
                              placeholder="country code"
                              :class="{ 'is-invalid': submitted && $v.form.country_code.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.country_code.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.country_code.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Refundable</label>
                          <select
                              id="refundable"
                              v-model="form.refundable"
                              name="refundable"
                              type="text"
                              class="form-control"
                              placeholder="Refundable"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.refundable.$error }">
                              <option value="" disabled style="display:none" selected>Select Refundable Type</option>
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                          </select>
                          <div
                              v-if="submitted && $v.form.refundable.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.refundable.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Cancellation Fee</label>
                          <input
                              id="cancellation_fee"
                              v-model="form.cancellation_fee"
                              name="cancellation_fee"
                              type="text"
                              class="form-control"
                              placeholder="cancellation fee"
                              :class="{ 'is-invalid': submitted && $v.form.cancellation_fee.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.cancellation_fee.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.cancellation_fee.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Contact Email</label>
                          <input
                              id="contact_email"
                              v-model="form.contact_email"
                              name="contact_email"
                              type="text"
                              class="form-control"
                              placeholder="contact email"
                              :class="{ 'is-invalid': submitted && $v.form.contact_email.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.contact_email.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.contact_email.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Contact Phone Code</label>
                          <input
                              id="contact_phone_code"
                              v-model="form.contact_phone_code"
                              name="contact_phone_code"
                              type="text"
                              class="form-control"
                              placeholder="contact phone code"
                              :class="{ 'is-invalid': submitted && $v.form.contact_phone_code.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.contact_phone_code.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.contact_phone_code.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label>Contact Phone</label>
                          <input
                              id="contact_phone"
                              v-model="form.contact_phone"
                              name="contact_phone"
                              type="text"
                              class="form-control"
                              placeholder="contact phone"
                              :class="{ 'is-invalid': submitted && $v.form.contact_phone.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.contact_phone.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.contact_phone.required">This value is required.</span>
                          </div>
                      </div>
                  </div>

              </div>
              <button class="btn btn-primary" type="submit">Update</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
